import { Component, ElementRef, OnInit, EventEmitter, Output, AfterViewChecked } from '@angular/core';
import { CommonDataService } from '../../common/services/common-data.service';
import { LoginService } from '../../common/services/Login.service';
import { GraphqlService } from '../../common/services/graphql.service';
import { HttpcallService } from '../../common/services/httpcall.service'
import { MatTableDataSource } from '@angular/material/table';
import { DomSanitizer } from '@angular/platform-browser';
import { PcsFilterCriteria, PendingIntegeration, Table_Pcs } from 'src/app/common/models/PendingIntegeration';
import { Router } from '@angular/router';
import { formatDate } from '@angular/common';
import { constObj } from 'src/app/common/Constants/constants';
import { SessionService } from '../../common/services/Session.service';
@Component({
  selector: 'app-pending-content-integeration',
  templateUrl: './pending-content-integeration.component.html',
  styleUrls: ['./pending-content-integeration.component.css']
})
export class PendingContentIntegerationComponent implements OnInit, AfterViewChecked {
  pc_lastPageVisitedButton: any;
  pc_searchToolButton: any;
  userId: any;
  userRole: string;

  constructor(public commonDataService: CommonDataService,
    public loginService: LoginService,
    private graphQlService: GraphqlService,
    private domSanitizer: DomSanitizer,
    private elementRef: ElementRef,
    private route: Router, private session: SessionService,
    private httpCallService: HttpcallService) { }
  public displayedColumns = ["Standardssource", "TransitionParagraph", "Title", "IntegrationStatus"];
  public dataSource = new MatTableDataSource<Table_Pcs>();
  public dataSource_specialCases = new MatTableDataSource<Table_Pcs>();
  public dataSource_earlyAdoption = new MatTableDataSource<Table_Pcs>();
  @Output() myEvent = new EventEmitter<string>();
  pc_header;
  pendingEnabled;
  pc_beginningDate;
  pc_filingStatuslabel;
  pc_confirmationMessage;
  pc_periodtypelabel;
  integerationvalues: PendingIntegeration = new PendingIntegeration();
  pc_intergration_header;
  pc_header_SpecialCases_Accordian;
  pc_header_EarlyAdoptions_Accordian;
  pc_integrationStatus_Subtitle;
  pc_integrationStatus_Accordion;
  pc_standardNumber;
  pc_transitionParagraph;
  pc_integrationStatus;
  pc_editInputs;
  pc_startOver;
  pc_title;
  TableData_Integration: Table_Pcs[] = [];
  TableData_EarlyAdoption: Table_Pcs[] = [];
  TableData_SpecialCases: Table_Pcs[] = [];
  userAccountId: string = "";
  generalFeedback: any = "General Feedback"
  PendingContentPageData = {
    pubId: "",
    pageId: "",
    paraId: ""
  };
  BreadcrumbData: any
  history: any;
  noRecords = constObj.Norecords;
  ngOnInit(): void {
    this.getUserId()
    this.commonDataService.showLoader.next(true);
   
    this.getpendingcontentsystemLabel();
    this.getpendingintegerationvalues();

  }

  firstTimeFlag: boolean = true;
  ngAfterViewChecked() {
    if (this.firstTimeFlag) {
      this.anchorColorChange();
      this.firstTimeFlag = false;
    }
  }

  anchorColorChange() {
    let items = document.getElementById("pc_confirmation_msg");
    let element = items;
    if (element != undefined && element != null) {
      element.addEventListener('click', this.Search.bind(this));
    }
  }
  Search() {
    this.commonDataService.openSearchMenu.next("open")
  }
  getUserId() {
    if (this.session.userInfo == undefined || this.session.userInfo.user == null) {
      this.loginService.getSession().subscribe(data => {
        this.MapLoginData(data);
        this.session.assignUserInfo(data.user);
      })
    }
    else {
      this.MapLoginData(this.session.userInfo);
    }
  }

  MapLoginData(loginData) {
    this.commonDataService.emailId.next(loginData.user.email);
    this.userId = loginData.user.firstname + " " + loginData.user.lastname;
    this.userRole = loginData.user.roles;
    this.getLastVisitedPage();
  }

  StartOver() {
    this.graphQlService.SetPCSIntegratedFlag(false).subscribe(data => {
      this.commonDataService.EditFromContentPage.next(false);
      localStorage.removeItem("isPendingContentPage");
      this.route.navigateByUrl("/pendingcontentsystem")
    });
  }
  EditInput() {
    let PCS = { fillingStatus: this.integerationvalues.selectedFillingStatus, periodType: this.integerationvalues.selectedPeriodType, Date: this.integerationvalues.selectedDate };
    localStorage.setItem("PCSInput", JSON.stringify(PCS));
    this.commonDataService.EditFromContentPage.next(true);
    this.route.navigateByUrl("/pendingcontentsystem");
  }
  getpendingcontentsystemLabel() {
    this.graphQlService.getPendingContentSystemLabels().subscribe(data => {
      if (data != "") {
        var labels = data.content.data.labels;
        labels = labels.filter(x => x.key.trim());
        this.pc_header = labels.filter(x => x.key == "pc_header").map(y => y.value);
        this.pc_beginningDate = labels.filter(x => x.key == "pc_beginningDate").map(y => y.value);
        this.pc_filingStatuslabel = labels.filter(x => x.key == "pc_filingStatus").map(y => y.value);
        this.pc_periodtypelabel = labels.filter(x => x.key == "pc_periodType").map(y => y.value);
        this.pc_confirmationMessage = this.domSanitizer.bypassSecurityTrustHtml(labels.filter(x => x.key == "pc_confirmationMessage").map(y => y.value));
        this.pc_intergration_header = labels.filter(x => x.key == "pc_integrationStatusHeader").map(y => y.value);
        this.pc_integrationStatus_Subtitle = labels.filter(x => x.key == "pc_integrationStatusSubtitle").map(y => y.value);
        this.pc_integrationStatus_Accordion = labels.filter(x => x.key == "pc_integrationStatusAccordion").map(y => y.value);
        this.pc_header_SpecialCases_Accordian = labels.filter(x => x.key == "pc_SpecailCasesAccordian").map(y => y.value);
        this.pc_header_EarlyAdoptions_Accordian = labels.filter(x => x.key == "pc_EarlyAdoptionAccordian").map(y => y.value);
        this.pendingEnabled = labels.filter(x => x.key == "pc_successfullyEnabled").map(y => y.value);
        this.pc_title = labels.filter(x => x.key == "pc_title").map(y => y.value);
        this.pc_standardNumber = labels.filter(x => x.key == "pc_standardNumber").map(y => y.value);
        this.pc_transitionParagraph = labels.filter(x => x.key == "pc_transitionParagraph").map(y => y.value);
        //this.pc_integrationStatus = labels.filter(x => x.key == "pc_integrationStatus").map(y => y.value);
        this.pc_integrationStatus = labels.filter(x => x.key == "pc_Status").map(y => y.value);
        this.pc_editInputs = labels.filter(x => x.key == "pc_editInputs").map(y => y.value);
        this.pc_startOver = labels.filter(x => x.key == "pc_startOver").map(y => y.value);
        this.pc_lastPageVisitedButton = labels.filter(x => x.key == "pc_lastPageVisitedButton").map(y => y.value);
        this.pc_searchToolButton = labels.filter(x => x.key == "pc_searchToolButton").map(y => y.value);


        this.commonDataService.showLoader.next(false);
      }
    }, err => {
      console.log(err);
      this.commonDataService.showLoader.next(false);
    });
  }
  getLastVisitedPage() {
    this.httpCallService.getMyHistory().subscribe(data => {
      this.history = data
      this.history = this.history.filter(x => x.historyType == "VisitedPages");
      if (data != null) {
        let crumbData = this.history[0].breadCrumb.toString().split('~');
        const obj = {
          crumbData: crumbData,
          menuData: []
        }
        this.BreadcrumbData = obj
      }
    }, err => {
      console.log(err);
      this.commonDataService.showLoader.next(false);
    });
  }
  ViewLastVisitedPage() {
    this.route.navigateByUrl(this.history[0].pageURL);

  }
  showResult: boolean = false;
  integratedData: any[];
  nonIntegratedData: any[];
  PcsFilterCriteria: PcsFilterCriteria;
  public getAllIntegrationStatus() {
    this.TableData_SpecialCases = this.integerationvalues.specialCases;
    this.TableData_EarlyAdoption = this.integerationvalues.earlyAdoption;
    //this.TableData_Integration = this.integerationvalues.integrationStatus;
    //this.PcsFilterCriteria = this.commonDataService.PCSFilterCriteria.getValue();
    //if (this.PcsFilterCriteria == null) {
    //  let obj: PcsFilterCriteria = {
    //    Date: new Date(this.integerationvalues.selectedDate),
    //    filingStatus: this.integerationvalues.selectedFillingStatus,
    //    periodType: this.integerationvalues.selectedPeriodType,
    //  }
    //  this.PcsFilterCriteria = obj;
    //}
    //this.graphQlService.getIntegratedPendingContent(this.PcsFilterCriteria).subscribe(res => {
    //  if (res) {
    //    this.integratedData = res;
    //    this.mapIntegratedPendingContent();
    //    this.showResult = true;
    //  }
    //})

    this.TableData_Integration = this.integerationvalues?.integrationStatus?.sort((a, b) => (a.title?.toLowerCase().replace(/[^a-z0-9]/g, "") < b.title?.toLowerCase().replace(/[^a-z0-9]/g, "")) ? 1 : -1);
    //this.TableData_Integration = this.TableData_Integration.filter(s => s.body = s.body.substring(s.body.indexOf(s.standardsource + ", ") + s.standardsource.length+2))
    this.TableData_Integration = this.TableData_Integration?.filter(s => s.body = s.body.substring(s.body.indexOf(", ") + 1))
    this.dataSource_specialCases.data = this.TableData_SpecialCases;
    this.dataSource_earlyAdoption.data = this.TableData_EarlyAdoption;
    this.dataSource.data = this.TableData_Integration;
    this.firstTimeFlag = true;
  }

  dateField: string;
  mapIntegratedPendingContent() {
    var response: any;
    var res: any[] = [];
    var id, result, alias;
    var public_nonpublic = this.PcsFilterCriteria.filingStatus.toLocaleLowerCase().includes("non-public") ? "NonPublic" : "Public";
    if (this.PcsFilterCriteria.filingStatus.toLocaleLowerCase().includes("business entity")) {
      alias = "Be";
    }
    else if (this.PcsFilterCriteria.filingStatus.toLocaleLowerCase().includes("employee benefit plans")) {
      alias = "Ebp"
    }
    else if (this.PcsFilterCriteria.filingStatus.toLocaleLowerCase().includes("not-for-profit")) {
      alias = "Nfp"
    }
    this.dateField = "effective" + this.PcsFilterCriteria.periodType + "Date" + public_nonpublic + alias;

    for (let i in this.integratedData) {
      id = this.integratedData[i].id;
      result = this.integratedData[i].source;
      response = this.mapValuesWithTable(id, result);
      res.push(response);
    }
    this.dataSource.data = res as Table_Pcs[]
  }

  mapValuesWithTable(id, result) {
    return {
      standardsource: result.standardUpdatePdfName,
      transistionguidance: result.transitionGuidanceTopicNum + '-' + result.transitionGuidanceSubtopicNum + '-' + result.transitionGuidanceParagraphNum,
      yesOrNo: new Date(result[this.dateField]) > this.PcsFilterCriteria.Date ? 0 : 1,
      id: id,
      standsourcepdffileName: result.standardUpdatePdfFilename,
      title: result.title,
      body: result.titleBody,
      filingStatus: this.PcsFilterCriteria.filingStatus,
      periodType: this.PcsFilterCriteria.periodType,
      standardSourcePubId: result.standardUpdateContentPubId,
      standardSourceId: result.id,
      topic: result.transitionGuidanceTopicNum,
      supbtopic: result.transitionGuidanceSubtopicNum,
      section: result.transitionGuidanceSectionNum,
      paragraph: result.transitionGuidanceParagraphNum,
      transitionGuidanceParagraphPubId: result.transitionGuidanceParagraphPubId,
      transitionGuidanceParagraphTopicId: result.transitionGuidanceParagraphTopicId,
      //pendingsupbtopic: result.pendingTextSubtopicNum,
      //pendingtopic: result.pendingTextTopicNum,
      //pendingsection: result.pendingTextSectionNum,
      //pendingparagraph: result.pendingTextParagraphNum,
      //pendingContentParagraphTopicId: result.pendingTextTopicId,
      //pendingContentParagraphPubId: result.pendingTextPubId,
      date: result.rolloffDate
    };

  }
  getpendingintegerationvalues() {
    this.graphQlService.GetPendingIntegrationSession().subscribe(data => {
      if (data != null && data != undefined && data != "") {
        this.integerationvalues = data;
        this.integerationvalues.selectedDate = formatDate(this.integerationvalues.selectedDate, 'MM/dd/yyyy', 'en-US');
        this.getAllIntegrationStatus();
      }
      else {
        this.route.navigateByUrl("/pendingcontentsystem");
      }


    }, err => {
      console.log(err);
      this.commonDataService.showLoader.next(false);
    });
  }
  RedirecttoPCS(element) {

    this.commonDataService.showRightPanel.next(true);
    this.commonDataService.rightPanelWidth.next("rightOverlay_large");
    this.PendingContentPageData = { pubId: element.transitionGuidanceParagraphPubId, pageId: element.transitionGuidanceParagraphTopicId, paraId: element.paragraph };
    this.commonDataService.rightOverlayOption.next("PendingContentviewer");
    this.commonDataService.rightOverlayPendingContentData.next(this.PendingContentPageData);

  }

}
export interface PCSIntegration {
  Standardssource: string
  TransitionParagraph: string;
  Title: string;
  IntegrationStatus: boolean;
}
